import { Fragment } from "react";

import { css } from "@compiled/react";
import { FormattedMessage } from "react-intl";

import { FormattedPriceCalculationResponse } from "../constants";
import { usePriceFinderStore } from "../store/store";

import { centerJustifiedStyling } from "./card-container";
import { PriceDisplay } from "./price-display";

const monthlyContainerStyles = css(centerJustifiedStyling);

const perUserTextStyles = css({
    fontSize: "16px",
    lineHeight: "24px"
});

const perMonthTextStyles = css({
    fontSize: "16px",
    lineHeight: "24px",
    fontWeight: "bold",
    marginBlockEnd: "32px",
    color: "#091e42"
});

export type MonthlyProps = {
    readonly priceCalc: FormattedPriceCalculationResponse;
    readonly fontSize: string;
    readonly planName: string;
};

export const Monthly = ({ priceCalc, fontSize, planName }: MonthlyProps) => {
    const { formattedTotalPrice, formattedAvgPerUnitPrice } = priceCalc;
    const [{ messages }] = usePriceFinderStore();

    return (
        <Fragment>
            <PriceDisplay
                planName={planName}
                formattedPrice={formattedAvgPerUnitPrice}
                fontSize={fontSize}
            />
            <div css={monthlyContainerStyles}>
                <div css={perUserTextStyles}>
                    <FormattedMessage {...messages.cardMonthlyPerUnitCount} />
                </div>
                <div css={perMonthTextStyles}>
                    <FormattedMessage
                        id="Pricing.PriceCard.Monthly.PerMonthText"
                        defaultMessage="{formattedTotalPrice} per month"
                        values={{ formattedTotalPrice }}
                    />
                </div>
            </div>
        </Fragment>
    );
};
